import { Control } from "react-hook-form";
import { SplitDatePickerFormField } from "../../../formfields/DatePickerFormField/SplitDatePickerFormField";
import { PersonsVirtualizedSelectForm } from "../../../forms/EntityForms/formsVirtualized/PersonsVirtualizedSelectForm";

export const ModificationRecordEntityFilterForm = ({ control }: { control: Control<any, any, any> }) => {
  return (
    <>
      <PersonsVirtualizedSelectForm
        id="modifiedByIds"
        label="Last modified by"
        control={control}
        isMulti
        filters={{ includeSystemUsers: true }}
      />

      <SplitDatePickerFormField
        control={control}
        idStart="modifiedFrom"
        idEnd="modifiedTo"
        label="Last modified on (from - to)"
        horizontal={false}
        showTimeSelect
      />
    </>
  );
};
